import React, {
  useContext, useEffect, useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';

import { Spinner } from '../../../components';
import {
  selectListScenes,
  selectCurrentSceneId,
} from '../../../store/modules/scenes/selectors';
import {
  getScenesRequest,
  setCurrentSceneId,
} from '../../../store/modules/scenes/actions';
import { selectLists } from '../../../store/modules/lists/selectors';
import { updateQuery } from '../../../utility/helpers';
import AddScriptAction from './actions/AddScriptAction';
import useStyles from './styles';
import { selectProject } from '../../../store/modules/projects/selectors';
import { SseContext } from '../../../services/SSE';
import ScriptForm from './ScriptForm';
import ScriptListAction from './actions/ScriptListAction';
import { ScriptEditorJSContext, useScriptEditorContext } from './ScriptContext';
import { getQueryParameter } from '../../../utility/queryParams';

const ScriptsPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const scenesList = useSelector(selectListScenes);
  const lists = useSelector(selectLists);
  const { data: project } = useSelector(selectProject);
  const currentSceneId = useSelector(selectCurrentSceneId);
  const scriptEditorContext = useScriptEditorContext();
  const { addSource } = useContext(SseContext);
  const canEdit = project?.permissions.can_edit || false;

  const currentScene = useMemo(() => {
    return scenesList.data?.items.find((item) => item.id === currentSceneId);
  }, [scenesList, currentSceneId]);

  useMemo(() => {
    scenesList.data?.items.forEach((item) => {
      addSource({
        url: item.ref.sse_topic,
        onMessage: (data) => {
          if (data.action === 'updated') {
            dispatch(getScenesRequest(item.id));
          }
        },
      });
    });
  }, [dispatch, scenesList.data, addSource]);

  useEffect(() => {
    const haveCurrentScene = scenesList.data?.items.some((scene) => scene.id === currentSceneId);

    if (scenesList.data?.items?.length) {
      const queryScriptId = Number(getQueryParameter('scriptId'));

      if (!Number.isNaN(queryScriptId)) {
        // update query if ids don`t match
        if (haveCurrentScene && currentSceneId !== queryScriptId) {
          updateQuery({ scriptId: currentSceneId });
        }
      } else if (haveCurrentScene) {
        // update query if not set
        updateQuery({ scriptId: currentSceneId });
        dispatch(setCurrentSceneId(currentSceneId));
      }
    }
  }, [dispatch, scenesList, currentSceneId]);

  useEffect(() => {

  }, [currentSceneId]);

  return (
    <ScriptEditorJSContext.Provider value={scriptEditorContext}>
      {(scenesList.loading || lists.loading)
      && (
        <Grid container className={classes.spinnerWrapper}>
          <Spinner />
        </Grid>
      )}
      <Grid container alignItems="center" className={classes.actionContainer}>
        {(scenesList.data && scenesList.data.items.length > 0)
          && (
            <Grid item className={classes.scriptListActionContainer}>
              <ScriptListAction
                scripts={scenesList.data.items}
                disabled={scenesList.loading}
              />
            </Grid>
          )}
        {canEdit
        && (
          <Grid item>
            <AddScriptAction />
          </Grid>
        )}
      </Grid>
      {currentScene && <ScriptForm scene={currentScene} />}
    </ScriptEditorJSContext.Provider>
  );
};

export default ScriptsPage;
